export const nameCellStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '12px',
  maxWidth: '100%',
};

export const nameTextStyles = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
